// src/pages/WastePieChart.jsx
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useFetch from '../../hooks/useFetch';

ChartJS.register(ArcElement, Tooltip, Legend);

const SmartyPieChart = () => {
  // ... setup ...
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    const config = {
      url: "/smartyitems/aggregate",
      method: "post",
      headers: { Authorization: token },
      data: { userId: user._id, year, month, sums: ['amount', 'wasteAmount'] }
    };
    fetchData(config).then(response => {
      setChartData({
        labels: ['Total Spend', 'Waste'],
        datasets: [{
          data: [response.totalAmount, response.totalWasteAmount],
          backgroundColor: ['rgba(54, 162, 235, 0.6)', 'rgba(255, 99, 132, 0.6)']
        }]
      });
    });
  }, [year, month]);

  return (
    <div className="min-h-screen bg-black text-blue-100 p-4">
      <div className="flex gap-4 mb-4">
        <select value={year} onChange={e => setYear(e.target.value)} className="bg-gray-800 text-white p-2 rounded">
          {[2024, 2025, 2026].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select value={month} onChange={e => setMonth(e.target.value)} className="bg-gray-800 text-white p-2 rounded">
          {Array.from({length: 12}, (_, i) => i+1).map(m => <option key={m} value={m}>Month {m}</option>)}
        </select>
      </div>
      <Pie data={chartData} />
    </div>
  );
};

export default SmartyPieChart;